import { connect } from "react-redux";

import DropZone from "./DropZone";

export default connect((state) => ({
  token: state.Auth.access_token,
  isMobile: state.Device.isMobile,
}))(DropZone);
